export default __webpack_public_path__ + "static/plantingSaplings-ab91afc73e47725bdd05bb114d836eaa.png";